module.exports = __webpack_public_path__ + "img/circle-parking.d1cee457.svg";